// src/pages/HorecaHubHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const HorecaHubHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Digital Income", emoji: "💰" },
    { label: "Learning & Development", emoji: "📚" },
    { label: "Owner Productivity", emoji: "⚡" },
    { label: "Micro CCM", emoji: "📅" },
    { label: "Assessment & Ranking", emoji: "🔄" },
    { label: "Finance & Compliance", emoji: "💰" },
    { label: "People & Innovation", emoji: "👥" },
    { label: "Customer & Business", emoji: "🛒" },
    { label: "Engagement", emoji: "💬" },
    { label: "HORECA Transformation", emoji: "🧗" },
  ];

  const menuButtons1 = [
    { label: "Monthly Digital Income", emoji: "💻🌱", link: "/msme-bookworld", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Digital Income" },
    { label: "ValueShare", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Resell", emoji: "♻️", link: "/msme-enroll", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥🌾", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Income" },

    { label: "HORECA Success Kit", emoji: "🧰", link: "/startupkit", group: "Learning & Development" },
    { label: "Owner's Awareness & Literacy", emoji: "📚", link: "/horecabookworld", group: "Learning & Development" },
    { label: "HORECA Monthly", emoji: "🗓️", link: "/msme-monthly", group: "Learning & Development" },
    { label: "HORECA Shelf", emoji: "📖", link: "/bookshelf", group: "Learning & Development" },
    { label: "HORECA Shorts", emoji: "🗞️", link: "/litenshort", group: "Learning & Development" },
    { label: "HORECA Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Learning & Development" },
    { label: "HORECA Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Learning & Development" },
    { label: "foodTube", emoji: "🎬", link: "/foodtube", group: "Learning & Development" },

    { label: "HORECA Self Assesment", emoji: "🙋‍♀️", link: "/horecahub-selfassessment", group: "Assessment & Ranking" },    
    { label: "HORECA Ranking", emoji: "🏆", link: "/sakshamhorecascore", group: "Assessment & Ranking" },
    { label: "Maturity Certificate", emoji: "💾", link: "/horecadb", group: "Assessment & Ranking" },

    { label: "Funding & Loans", emoji: "💰", link: "/fundlanes", group: "Finance & Compliance" },
    { label: "PMMY", emoji: "💪", link: "/growsure", group: "Finance & Compliance" },

    { label: "Year Book", emoji: "📔", link: "/msmeyb-home", group: "Owner Productivity" },
    { label: "DeepThinking Lab", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Owner Productivity" },
    { label: "Daily Tasks", emoji: "📘", link: "/life-chronicles-home", group: "Owner Productivity" },
    { label: "Minutes of Meeting", emoji: "📝", link: "/tasks/add", group: "Owner Productivity" },
    { label: "Goal Board", emoji: "🎯", link: "/msme-goalboard", group: "Owner Productivity" },
    { label: "Process & RACI Board", emoji: "📋", link: "/msme-processraci", group: "Owner Productivity" },
    { label: "Kanban", emoji: "🗂️", link: "/msme-kanban", group: "Owner Productivity" },
    { label: "CommuniCapture", emoji: "🟢", link: "/communicapture-home", group: "Owner Productivity" },
    { label: "LLM Capture", emoji: "🤖", link: "/msme-llmcapture", group: "Owner Productivity" },

    // 🔄 MSME CCM (Contacts. Communication. Meetings)
    { label: "My Digital Card", emoji: "📘", link: "/msme-digitalcard", group: "Micro CCM" },
    { label: "Client's Digital Card", emoji: "📘", link: "/contact-genious-clientcards", group: "Micro CCM" },
    { label: "My Speaking Card", emoji: "📘", link: "/contact-genious-speakingcard", group: "Micro CCM" },
    { label: "Card Visibility Dashbaord", emoji: "📘", link: "/contact-genious-cardviewstats", group: "Micro CCM" },
    { label: "Connect / PehchaanSetu", emoji: "📝", link: "/pehchaansetu", group: "Micro CCM" },
    { label: "Meeting Calendar", emoji: "📝", link: "/calendar-list", group: "Micro CCM" },    
    { label: "Visits for Meeting", emoji: "📝", link: "/visits-list", group: "Micro CCM" },   
    { label: "Meeting Thoughts", emoji: "📝", link: "/thoughts-list", group: "Micro CCM" },   
    { label: "Meeting TODO", emoji: "📝", link: "/todo-list", group: "Micro CCM" },   
    { label: "Meeting Tasks", emoji: "📝", link: "/tasks-list", group: "Micro CCM" },   
    { label: "Travelling for Meetings", emoji: "📝", link: "/travels-list", group: "Micro CCM" },   
    { label: "Meeting Checklist", emoji: "📝", link: "/checklist-list", group: "Micro CCM" },   
    { label: "Meeting Record", emoji: "📝", link: "/meetings-list", group: "Micro CCM" },
    { label: "Whisper", emoji: "📝", link: "", group: "Micro CCM" },
    { label: "Meeting Analytics AI", emoji: "📝", link: "", group: "Micro CCM" },

    { label: "HORECA Workforce", emoji: "🧤", link: "/bluehands-home", group: "People & Innovation" },
    { label: "Counselling", emoji: "🧠", link: "/aicounselling-about", group: "People & Innovation" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "People & Innovation" },
    { label: "Consultants", emoji: "👨‍💼", link: "/think5whys-counsellors", group: "People & Innovation" },
    { label: "Offboarded DB", emoji: "👨‍💼", link: "/offboarded-home", group: "People & Innovation" },
    { label: "Payment Dodger DB", emoji: "👨‍💼", link: "/offboarded-home", group: "People & Innovation" },
    { label: "Design Of Experiments", emoji: "📊", link: "/doe", group: "People & Innovation" },
    { label: "Innovations", emoji: "💡", link: "/agrilink-innovationhub", group: "People & Innovation" },
    { label: "HORECA2Farmers", emoji: "👳", link: "/mykisan", group: "People & Innovation" },

    { label: "Table Orders Dashboard", emoji: "🍽️", link: "/horecahub-e2e", group: "Customer & Business" },
    { label: "Take Away Orders Dashboard", emoji: "🥡", link: "/horeca-e2e", group: "Customer & Business" },
    { label: "Home Orders Dashboard", emoji: "🚴‍♂️", link: "/horecahub-e2e", group: "Customer & Business" },
    { label: "Hotel2Farm Bulk Order", emoji: "🏨➡️🌾", link: "/orderflow-home", group: "Customer & Business" },
    { label: "Farm2Hotel Bulk Supply", emoji: "🌾➡️🏨", link: "/orderflow-home", group: "Customer & Business" },
    { label: "Services", emoji: "🧰", link: "/thinkserice-home", group: "Customer & Business" },
    { label: "HORECA Rental", emoji: "🏨", link: "/thinkrental-home", group: "Customer & Business" },
    { label: "Marketplace", emoji: "🛒", link: "/orderflow-home", group: "Customer & Business" },
    { label: "Tenders", emoji: "📑", link: "/horecahub-tenders", group: "Customer & Business" },
    { label: "Waste & Leftovers", emoji: "♻️", link: "/horecahub-wastes", group: "Customer & Business" },
    { label: "Buyer Digital Twin", emoji: "🌐", link: "/twiworld", group: "Customer & Business" },
    { label: "FoodX Digital Twin", emoji: "🍛", link: "/foodx", group: "Customer & Business" },

    { label: "Khau Gali MetaVerse", emoji: "🕶️", link: "/horecahub-metaverse", group: "Customer & Business" },

    { label: "CSAT", emoji: "💬", link: "/csat", group: "Engagement" },
    { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "Engagement" },
    { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "Engagement" },
    { label: "HORECA Games", emoji: "🎮", link: "/msme-games", group: "Engagement" },

    { label: "HORECAHub FAQ", emoji: "🤔", link: "/horecahub-whyhoreca", group: "HORECA Transformation" },
    { label: "Starting a HORECA", emoji: "🛎️", link: "/horeca-about", group: "HORECA Transformation" },
    { label: "Adoption Ladder", emoji: "🪜", link: "/msme-think5whysmaturity", group: "HORECA Transformation" },
    { label: "Stakeholders", emoji: "👨‍💼", link: "/msme-think5whysroles", group: "HORECA Transformation" },
    { label: "HORECA Advisors", emoji: "🤝", link: "/msme-advisors", group: "HORECA Transformation" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-gray-950 text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-gray-900 border-b border-gray-800 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-xl font-bold text-teal-300">HORECA Hub</div>
          <div className="text-[11px] text-gray-400">Hotel. Restaurant. Cafeteria</div>
          <div className="text-[11px] text-yellow-200">Owner Centric. Transparency. Connecting Skill with Productivity</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 font-medium text-xs">{userName}</div>
              <div className="flex gap-3">
                <button
                  onClick={handleLogout}
                  className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">Login</Link>
            </div>
          )}

          {/* <div className="mt-3 flex flex-wrap justify-center gap-3 text-sm text-gray-200">
            <a href="/horecahub-insights" className="hover:text-yellow-300">💭 About HORECA</a>
            <a href="/horecahub-vsai" className="hover:text-yellow-300">🤖 HORECA & AI</a>
            <Link to="/litenshort" className="hover:text-yellow-300">🗞️ Short News</Link>
            <a href="/fundlanes" className="hover:text-yellow-200">💰 Funding</a>
            <a href="/ledger" className="hover:text-yellow-200">📊 HORECA ERP</a>
            <a href="/horecahub-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          </div> */}
        </div>
      )}

      {/* Top quick links (desktop + mobile inline area) */}
      <div className="bg-cyan-800 text-white text-xs sm:text-sm py-2">
        <div className="mx-auto px-1 flex flex-wrap justify-center gap-2">
          <a href="/foodx" className="hover:text-white">🍚 Food<span className="text-cyan-400">X</span></a>
          {/* <a href="/horecahub-vsai" className="hover:text-yellow-200">🤖 HORECA AI</a> */}
          {/* <Link to="/litenshort" className="hover:text-yellow-200">🗞️ News</Link> */}
          <a href="/ledger" className="hover:text-yellow-200">📊 HORECA ERP</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>          
          <a href="/horecahub-insights" className="hover:text-yellow-200">💭 About</a>          
        </div>
      </div>

      {/* Tabs (categories) */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main content area with grid of buttons */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 lg:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      <footer className="bg-gray-900 border-t border-gray-800 text-gray-400 py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HorecaHubHome;
